export default {
  Language: {
    ru: 'Русский',
    en: 'English',
    fr: 'Français',
  },
  Common: {
    ReturnToShop: 'Вернуться в магазин',
  },
  Brand: {
    Title: 'Оплата заказа',
    DescriptionLabel: 'Описание заказа',
    Description: 'Оплата заказа №{{order}} в магазине',
    DescriptionNamed: 'Оплата заказа №{{order}} в магазине {{merchant}}',
    DateLabel: 'Дата создания',
  },
  CardPage: {
    Title: 'Оплата банковской картой',
    AmountLabel: 'Сумма к оплате',
  },
  FormField: {
    CardNumber: 'Номер карты',
    CardMonthYear: 'Срок действия',
    CardCVC: 'CVV',
    ShowCvc: 'Показать CVV',
    HideCvc: 'Скрыть CVV',
  },
  FormError: {
    Card: {
      pan: {
        required: 'Заполните поле.',
        invalid: 'Некорректный номер карты.',
      },
      name: {
        required: 'Заполните поле.',
        invalid: 'Нужны лат. символы, пробелы, точка, тире (до 30).',
      },
      cvc: {
        required: 'Заполните поле.',
        invalid: 'Заполните поле.',
      },
      expiry: {
        required: 'Заполните поле.',
        month: {
          invalid: 'Значение от 01 до 12.',
        },
        year: {
          invalid: 'Текущий или следующие годы.',
        },
      },
    },
  },
  PaymentStatus: {
    Title: {
      complete: 'Оплата прошла успешно',
      partial_complete: 'Оплата прошла частично',
      failed: 'Оплата не прошла',
      pending: 'Проверяем платёж',
    },
    Text: {
      complete: 'Платёж на сумму {{amount}} успешно обработан. Чек отправлен на вашу почту.',
      partial_complete: 'Платёж на сумму {{amount}} обработан частично. Свяжитесь с магазином для уточнения деталей.',
      failed: 'Не удалось завершить платеж. Повторите попытку или обратитесь в банк, выпустивший вашу карту',
      pending: 'Это займёт несколько секунд. Пожалуйста, не закрывайте страницу.',
    },
    AmountLabel: {
      complete: 'Оплачено',
      partial_complete: 'Оплачено',
      failed: 'К оплате',
      pending: 'К оплате',
    },
  },
  Action: {
    Pay: 'Оплатить',
    Retry: 'Повторить оплату',
  },
  FatalError: {
    SomethingWentWrong: 'Что-то пошло не так.',
    Code: {
      NO_TERMINALS_AVAILABLE: 'Нет доступных терминалов для данного способа оплаты.',
      FORM_PAY_ALREADY_SUBMITED: 'Пожалуйста, вернитесь в магазин для повторной оплаты.',
      FORM_PAY_ALREADY_SUBMITTED: 'Пожалуйста, вернитесь в магазин для повторной оплаты.',
      COMMON_ERROR: 'Ошибка при проведении оплаты.',
      DUPLICATE_ORDER_ERROR: 'Заказ с таким номером уже существует.',
      ROUTE_ERROR: 'Отсутствует возможность проведения данного платежа.',
    },
  },
}
